const EmptyState = ({ message }) => (
    <div className="flex flex-col gap-5 items-center py-20">
		<img src="/images/empty-logs.svg" alt="empty state" />
		<h2 className="text-sub font-medium text-black">{message}</h2>
	</div>
)

export default EmptyState;


